// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__1DdaR","active":"NavItem_active__r12Op"};